<div class="signature-matrix-container" appUserManual [userManualKey]="'signature-matrix-template-list'">

  @if (needsDefaultTemplate) {
    <div class="default-template-warning">
      <mat-icon color="warn">warning</mat-icon>
      <span>A default template (no discipline) is required when discipline-specific templates exist.</span>
    </div>
  }

  @if (isLoading()) {
    <div class="spinner-container">
      <div class="spinner-wrapper">
        <app-spinner></app-spinner>
      </div>
    </div>
  } @else {
    @for (group of disciplineGroups; track group.label) {
      <div class="discipline-group">
        <div class="discipline-group-header">
          <h4>{{ group.label }}</h4>
          <div class="discipline-group-actions">
            @if (group.templates.length > 0) {
              <button mat-stroked-button (click)="cloneGroupToDiscipline(group)">
                <mat-icon>content_copy</mat-icon> Clone to Discipline
              </button>
            }
          </div>
        </div>

        <table mat-table [dataSource]="group.templates">
          <ng-container matColumnDef="ordinal">
            <th mat-header-cell *matHeaderCellDef>Ordinal</th>
            <td mat-cell class="ordinal" *matCellDef="let element">{{ element.ordinal }}</td>
          </ng-container>
          <ng-container matColumnDef="verified">
            <th mat-header-cell *matHeaderCellDef>Organisation</th>
            <td mat-cell class="verified" *matCellDef="let element">{{ element.verified || element.signatureRole?.description || 'N/A' }}</td>
          </ng-container>
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef>ROLE</th>
            <td mat-cell class="role" *matCellDef="let element">{{ element.role || element.signatureRole?.name || 'N/A' }}</td>
          </ng-container>
          <ng-container matColumnDef="signee">
            <th mat-header-cell *matHeaderCellDef>Signee</th>
            <td mat-cell class="signee" *matCellDef="let element">{{ element.signee?.name || 'N/A' }}</td>
          </ng-container>
          <ng-container matColumnDef="signatureRole">
            <th mat-header-cell *matHeaderCellDef>Signature Role</th>
            <td mat-cell class="signatureRole" *matCellDef="let element">{{ element.signatureRole?.name || 'N/A' }}</td>
          </ng-container>
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef>Edit</th>
            <td mat-cell class="edit" *matCellDef="let element">
              <button class="edit-button" (click)="editSignatureMatrix(element)" mat-flat-button><mat-icon>edit</mat-icon></button>
            </td>
          </ng-container>
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef>Delete</th>
            <td mat-cell class="delete" *matCellDef="let element">
              <button class="edit-button" (click)="deleteSignatureMatrix(element)" mat-flat-button><mat-icon>delete</mat-icon></button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <div class="action-buttons">
          <button mat-button (click)="addSignatureMatrixRow(group)">Add Row</button>
        </div>
      </div>
    }
  }

  <div class="action-buttons global-actions">
    <button mat-button color="primary" (click)="addForDiscipline()">
      <mat-icon>add_circle_outline</mat-icon> Add for Discipline
    </button>
  </div>
</div>
